import React from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const DonationCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const transactionId = searchParams.get("transaction_id");
  
  // Get the form data from location state (if available)
  const formData = location.state?.formData || null;

  const handleTryAgain = () => {
    // Navigate back to donation page with the form data in state
    navigate("/donation", { 
      state: { 
        preservedFormData: formData,
        preserveData: true 
      } 
    });
  };

  const handleReturnHome = () => {
    navigate("/");
  };

  return (
    <motion.div
      className="container py-5 min-vh-100 d-flex align-items-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="row justify-content-center w-100">
        <div className="col-md-8 col-lg-6">
          <div className="card border shadow-sm rounded-4 text-center p-5">
            <div className="text-warning mb-4">
              <i
                className="bi bi-exclamation-circle-fill"
                style={{ fontSize: "5rem" }}
              ></i>
            </div>

            <h2 className="fw-bold mb-3">Payment Cancelled</h2>
            <p className="text-muted mb-4">
              Your payment was cancelled. No charges have been made to your
              account.
            </p>

            {transactionId && (
              <div className="bg-light rounded-3 p-3 mb-4">
                <p className="mb-0">
                  <span className="text-muted">Transaction ID:</span>{" "}
                  <span className="fw-semibold">{transactionId}</span>
                </p>
              </div>
            )}

            <div className="d-flex gap-3 justify-content-center">
              <button
                className="btn btn-warning text-white rounded-pill px-4 py-2 fw-bold"
                onClick={handleTryAgain}
              >
                Try Again
              </button>
              <button
                className="btn btn-outline-secondary rounded-pill px-4 py-2"
                onClick={handleReturnHome}
              >
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default DonationCancel;